module.exports = __webpack_public_path__ + "static/media/af.e8963830.png";